export enum TextClassNames {
  SemiBoldText = 'semi-bold-text',
  LinkText = 'link-text',
  InformativeText = 'informative-text',
}
